export const filtersSelector = ({ filters }) => filters;
